module.exports = __webpack_public_path__ + "img/mr.6b6006fe.jpg";